import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import { Paper, Typography, FormControl, InputLabel, Input, Button } from '@material-ui/core'
import { NavLink, Link } from 'react-router-dom'
import { useStyles } from './user-login.styles'
import { ILoginUserInput } from 'app/shared/data-access/users/login-user/login-user-input'
import * as yup from 'yup'

type Props = {
  onLogin: (input: ILoginUserInput) => Promise<void>
  isBusy: boolean
}

const UserLoginView = (props: Props) => {
  const classes = useStyles()
  const { isBusy } = props

  const validateSchema = yup.object().shape({
    email: yup.string().email('Geen geldig e-mailadres').required('Dit veld is verplicht'),
    password: yup.string().required('Dit veld is verplicht'),
  })

  return (
    <>
      <Formik
        initialValues={{ email: '', password: '' } as ILoginUserInput}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(false)
          await props.onLogin(values)
        }}
        validationSchema={validateSchema}
      >
        {({ errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, initialValues, isValid }) => (
          <main className={classes.main}>
            <Paper className={classes.paper}>
              <Link to={{ pathname: `//axs-ict.com` }} target="_blank" >
                <img src="/axs_logo_payoff.png" className={classes.branding} alt="AXS logo" />
              </Link>
              <Typography component="div" variant="h6" className={classes.headerCaption}>
                Welkom op de portal voor coworking spaces
              </Typography>
              <form className={classes.form} onSubmit={handleSubmit}>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="email">E-mail</InputLabel>
                  <Input
                    defaultValue={initialValues.email}
                    id="email"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <div>
                    <label className={classes.errorLabel}>{errors.email && touched.email && errors.email}</label>
                  </div>
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                  <InputLabel htmlFor="password">Wachtwoord</InputLabel>
                  <Input
                    defaultValue={initialValues.password}
                    name="password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <div>
                    <label className={classes.errorLabel}>
                      {errors.password && touched.password && errors.password}
                    </label>
                  </div>
                </FormControl>

                <Button
                  disabled={isBusy || isSubmitting || !isValid}
                  onClick={(e: React.MouseEvent | React.KeyboardEvent) => {
                    e.preventDefault()
                    handleSubmit()
                  }}
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Inloggen
                </Button>
                <NavLink to="/forgot-password">Portal Wachtwoord Reset</NavLink>
              </form>
            </Paper>
          </main>
        )}
      </Formik>
    </>
  )
}

UserLoginView.propTypes = {
  onLogin: PropTypes.func,
}

export default UserLoginView
